import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = {
  key: 0,
  class: "formContainer"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { colspan: "10" }
const _hoisted_6 = { class: "fs_12 fw-bold red h-100" }
const _hoisted_7 = { class: "h-100 d-flex flex-column" }
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h1',
        localizedKey: "Licenses available",
        text: "Licenses available",
        class: "mb-0"
      })
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_op_table, {
            class: "table table-striped",
            items: _ctx.items
          }, {
            default: _withCtx((opData) => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Services",
                      text: "Services"
                    })
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Concurrent Accesses",
                      text: "Concurrent Accesses"
                    })
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Months",
                      text: "Months"
                    })
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Total Price",
                      text: "Total Price"
                    })
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Final Price",
                      text: "Final Price"
                    })
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Total Price Per Month",
                      text: "Total Price Per Month"
                    })
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Final Price Per Month",
                      text: "Final Price Per Month"
                    })
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Total Price Per User Per Month",
                      text: "Total Price Per User Per Month"
                    })
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Final Price Per User Per Month",
                      text: "Final Price Per User Per Month"
                    })
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Discount %",
                      text: "Discount %"
                    })
                  ]),
                  _hoisted_3
                ])
              ]),
              _createElementVNode("tbody", null, [
                (opData.data.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                      _createElementVNode("td", _hoisted_5, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "No Elements Found",
                          text: "No Elements Found"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.data as OM.ServiceSoldVM[]), (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                    _createElementVNode("td", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((item.garmentsCalculation as OM.TextIdentifier[]), (garm, k) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: "me-1 ms-1 mb-1",
                            key: k
                          }, _toDisplayString(garm.text), 1))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.userLicense), 1),
                    _createElementVNode("td", null, _toDisplayString(item.monthDuration), 1),
                    _createElementVNode("td", null, _toDisplayString(item.percentageDiscount ? _ctx.$filters.currency(_ctx.priceWithoutDiscount(item.price, item.percentageDiscount)) + ' CHF' : '-'), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$filters.currency(item.price)) + " CHF", 1),
                    _createElementVNode("td", null, _toDisplayString(item.percentageDiscount ? _ctx.$filters.currency(_ctx.priceWithoutDiscountPerMonth(item.price, item.percentageDiscount, item.monthDuration)) + ' CHF' : '-'), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$filters.currency(item.price / item.monthDuration)) + " CHF", 1),
                    _createElementVNode("td", null, _toDisplayString(item.percentageDiscount ? _ctx.$filters.currency(_ctx.priceWithoutDiscountPerUserPerMonth(item.price, item.percentageDiscount, item.monthDuration, item.userLicense)) + ' CHF' : '-'), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$filters.currency(item.price / item.monthDuration / item.userLicense)) + " CHF", 1),
                    _createElementVNode("td", null, _toDisplayString(item.percentageDiscount ? item.percentageDiscount + "%" : '-'), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: ($event: any) => (_ctx.buyItem(item))
                      }, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Buy",
                          text: "Buy"
                        })
                      ], 8, _hoisted_8)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["items"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}